/**
 * Single source of truth for PDF Tool Categories.
 *
 * Consumers:
 *  - ToolCatalogPage  → uses id + label (for filter pills and URL ?cat= param)
 *  - LeftSidebar      → uses id + label + textColor (for sidebar sub-menu dots)
 *  - MobileDrawer     → uses id + label + bgColor  (for drawer sub-menu dots)
 *
 * Adding a new category? Edit only this file — all components update automatically.
 */

/** @type {Array<{id: string, label: string, bgColor: string, textColor: string}>} */
export const TOOL_CATEGORIES = [
  { id: 'all',           label: 'All Tools',        bgColor: 'bg-gray-400',     textColor: 'text-theme-muted'  },
  { id: 'organize-pdf',  label: 'Organize PDF',     bgColor: 'bg-violet-400',   textColor: 'text-violet-400'   },
  { id: 'optimize-pdf',  label: 'Optimize PDF',     bgColor: 'bg-green-400',    textColor: 'text-green-400'    },
  { id: 'convert-to',    label: 'Convert to PDF',   bgColor: 'bg-emerald-400',  textColor: 'text-emerald-400'  },
  { id: 'convert-from',  label: 'Convert from PDF', bgColor: 'bg-yellow-400',   textColor: 'text-yellow-400'   },
  { id: 'edit-pdf',      label: 'Edit PDF',         bgColor: 'bg-cyan-400',     textColor: 'text-cyan-400'     },
  { id: 'security',      label: 'Security',         bgColor: 'bg-amber-400',    textColor: 'text-amber-400'    },
  { id: 'intelligence',  label: 'Intelligence',     bgColor: 'bg-fuchsia-400',  textColor: 'text-fuchsia-400'  },
  // { id: 'advanced-ai',   label: 'Advanced AI / OCR',bgColor: 'bg-sky-400',      textColor: 'text-sky-400'      },
];
